import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-06b308be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cw-summarized-item-name" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "cw-summarized-item",
    style: _normalizeStyle({ 'z-index': this.zindex })
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(this.name), 1),
    (this.hasSummaryHtml)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "cw-summarized-item-summary",
          innerHTML: this.summaryHtml
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "cw-summaryOptionButton",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.select && this.select(...args)))
    }, _toDisplayString(this.buttonText), 1)
  ], 4))
}